module.exports = __webpack_public_path__ + "img/certificate1-02.bee6ee48.png";